import React, { useState } from "react";
import { Header } from "./Header";
import { SideBar } from "./SideBar";

import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import { IconButton } from "@mui/material";
import { BackButton } from "../../assets/BackButton";

type LayoutProps = {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
};

export function Layout({ children, sidebar }: LayoutProps) {
  const [openMobileMenu, setOpenMobileMenu] = useState(false);

  const isDashboard =
    window.location.pathname === "/stores" ||
    window.location.pathname === "/";

  const toggleMenu = (state: boolean) => () => {
    setOpenMobileMenu(state);
  };

  return (
    <div className="min-h-screen max-w-screen text-gray-700 font-sans">
      <div className="headerWrapper">
        <div className="headerContainer">
          <Header />
        </div>
      </div>
      {sidebar && (
        <div className="mobile-side-menu">
          <IconButton onClick={toggleMenu(true)}>
            <MenuIcon />
          </IconButton>
        </div>
      )}

      <div className="layout">
        {sidebar && (
          <aside className="w-[20%] min-h-screen bg-gray-100 layout-sidebar">
            {sidebar}
          </aside>
        )}

        <main
          role="main"
          id="mainContent"
          className={isDashboard ? "relative dashboard" : "relative"}
        >
          {children}
        </main>
      </div>

      {sidebar && (
        <Drawer open={openMobileMenu} onClose={toggleMenu(false)}>
          <div className="mobile-drawer-content">
            <button className="backBtn" onClick={() => setOpenMobileMenu(false)} >
              <BackButton color={"black"} />
            </button>
            {sidebar}
          </div>
        </Drawer>
      )}
    </div>
  );
}
